<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <HelperNav />
          <div class="dashboard-wrapper">
            
            <div class="ar-card">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  واریز 
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">
                
                <template v-if="step === 1">

                  <div class="text-primary-dark m-auto" style="max-width:500px;">
                    
                    <div class="ar-form-group">
                      <label>ارز واریزی</label>
                      <select class="ar-form-control text-center" v-model="deposit.paid_currency">
                        <option :value="null" disabled hidden>انتخاب ارز واریزی</option>
                        <option value="IRR">تومان</option>
                        <option value="USDT">تتر</option>
                      </select>
                      <div v-if="errors.paid_currency" class="ar-form-text">
                        <small>انتخاب ارز واریزی الزامی است.</small>
                      </div>
                    </div>

                    <div class="ar-form-group">
                      <label>مقدار واریزی</label>
                      <input onclick="this.select()" class="ar-form-control text-center" type="number" @keypress="just_float($event)" v-model="deposit.paid_amount">
                      <div v-if="deposit.paid_currency == 'IRR'">
                        <small v-if="deposit.paid_amount">معادل {{formatPrice(deposit.paid_amount)}} تومان</small>
                      </div>
                      <div v-if="errors.paid_amount" class="ar-form-text">
                        <small>{{ errors.paid_amount[0] }}</small>
                      </div>
                    </div>

                    <template v-if="deposit.paid_currency === 'IRR'">

                      <div class="ar-form-group pt-3">
                        <div class="text-center py-1">
                          <add-bank-account>
                            <button class="ar-btn size-xs primary round">افزودن کارت بانکی <i class="mdi mdi-plus"></i></button>
                          </add-bank-account>
                        </div>
                        <select class="ar-form-control text-center" v-model="deposit.bank_account_id">
                          <option :value="null" disabled hidden>انتخاب کارت بانکی</option>
                          <option v-for="(item , key) in state_bank_accounts" :key="key" :value="item.id">{{ item.card_number }}</option>
                        </select>
                        <div v-if="errors.bank_account_id" class="ar-form-text">
                          <small>انتخاب کارت بانکی الزامی است.</small>
                        </div>
                      </div>

                      <h3 class="mt-3"> <i style="position:relative;top:6px" class="mdi mdi-circle"></i> روش های پرداخت</h3>
                      <div class="buy-sell-payment-method">

                        <div class="payment-method-item disabled" :class="[deposit.payment_method == 'gateway' ? 'active' : '']" >
                          <div class="payment-method-bullet"></div>
                          <div class="payment-method-title">پرداخت اینترنتی</div>
                        </div>

                        <div class="payment-method-item" :class="[deposit.payment_method == 'card' ? 'active' : '']" @click="deposit.payment_method = 'card'">
                          <div class="payment-method-bullet"></div>
                          <div class="payment-method-title">پرداخت از طریق بانک, همراه بانک و کارت به کارت</div>
                        </div>

                        <div class="payment-method-item disabled" :class="[deposit.payment_method == 'credit' ? 'active' : '']" >
                          <div class="payment-method-bullet"></div>
                          <div class="payment-method-title"> پرداخت اعتباری (از سبد دارایی)</div>
                        </div>

                        <div class="payment-method-item disabled" :class="[deposit.payment_method == 'vandar' ? 'active' : '']">
                          <div class="payment-method-bullet"></div>
                          <div class="payment-method-title">پرداخت از طریق سرویس وندار</div>
                        </div>

                      </div>

                      <div class="text-center py-3">
                        <button v-if="!deposit.paid_amount || !deposit.payment_method || !deposit.bank_account_id || !state_setting.allow_deposit" class="ar-btn size-xl round primary disabled">ادامه</button>
                        <template v-else>

                          <button v-if="deposit.payment_method == 'card'" class="ar-btn size-xl round primary" @click="getAdminAccount()">ادامه</button>

                        </template>
                      </div>
                      
                    </template>

                    <template v-if="deposit.paid_currency === 'USDT'">
                      <div>شبکه انتقال را انتخاب کنید.</div>
                        
                      <div class="buy-sell-select-networks">
                        <div v-for="(item , key) in networks" :key="key" class="select-networks-item font-en">
                          <button class="ar-btn size-lg round" :class="[admin_wallet.network === item.network ? 'primary' : 'disabled']" @click="admin_wallet = item">{{ item.network }}</button>
                        </div>
                      </div>



                      <div class="ar-form-group">
                        <label>تتر واریزی خود را بر اساس شبکه انتخاب شده به آدرس ولت زیر ارسال نمایید.</label>
                        <div class="ar-form-append">
                          <input disabled class="ar-form-control text-center font-en" v-model="admin_wallet.address">
                          <span class="ar-form-icon popover-activator" tabindex="1" @click="CopyText(admin_wallet.address)">
                            <i class="mdi mdi-content-copy"></i>
                            <span class="ar-popover">
                              کپی شد
                            </span>
                          </span>
                        </div>
                      </div>
                      <div v-if="admin_wallet.qr_code_file" class="text-left">
                        <small class="cp" @click="qr_code_modal = true">نمایش کد QR<i class="mdi mdi-qrcode"></i></small>
                      </div>

                      <div class="ar-form-group">
                        <label>
                          لطفا هش تراکنش را وارد کنید.
                          <i class="mdi mdi-information-outline"></i>
                        </label>
                        <input class="ar-form-control text-center font-en" placeholder="TXID" v-model="deposit.txid">
                      </div>

                      <div class="text-center">
                        <button v-if="!deposit.txid || !deposit.paid_amount" class="ar-btn size-md round primary disabled">ثبت</button>
                        <button v-else class="ar-btn size-md round primary" @click="submitDepositReq()">ثبت</button>
                      </div>
                      
                    </template>

                  </div>

                </template>

                <template v-if="step === 2">
                  <div class="text-primary-dark m-auto" style="max-width:400px;">

                    <template v-if="deposit.paid_currency === 'IRR'">

                      <template v-if="deposit.payment_method === 'card'">
                        
                        <small>کاربر گرامی , لطفا فقط از حساب های بانکی خودتان استفاده کنید.</small>
                        <small>درصورت مغایرت در نام خریدار و نام صاحب حساب , درخواست واریز باطل و مبلغ بعد از 
                          72 ساعت به مبدا بازگشت داده می شود.</small>

                        <div class="my-4">
                          <h4 class="text-center">
                          حساب های مورد تایید صرافی ارزینه, افتخار پارسیان
                          </h4>
                        </div>
  
                        <div class="ar-form-group">
                          <label>
                            کاربر گرامی برای واریز وجه خود لطفا یکی از حساب های زیر را انتخاب نمایید.
                          </label>
                          <select @change="selectAdminBankAccount()" class="ar-form-control text-center" v-model="deposit.admin_bank_account_id">
                            <option :value="null" disabled hidden>انتخاب حساب بانکی ارزینه</option>
                            <option v-for="(item , key) in admin_bank_accounts" :key="key" :value="item.id">{{ item.card_name }}</option>
                          </select>
                          <div v-if="errors.admin_bank_account_id" class="ar-form-text">
                            <small>انتخاب حساب بانکی الزامی است.</small>
                          </div>
                        </div>


                        <template v-if="admin_bank_account.id">
                          <!-- <div class="ar-form-group">
                            <label>نام صاحب حساب</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.card_name">
                          </div> -->

                          <div v-if="admin_bank_account.bank_name" class="text-center py-3">
                            <img :src="StaticImageUrl+'assets/images/banks/'+ admin_bank_account.bank_name +'.svg'" width="60px" class="m-auto">
                          </div>
                          
                          <div class="ar-form-group">
                            <label>شماره کارت</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.card_number">
                          </div>
                          
                          <div class="ar-form-group">
                            <label>شماره حساب</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.account_number">
                          </div>
                          
                          <div class="ar-form-group">
                            <label>شماره شبا</label>
                            <input class="ar-form-control text-center" disabled v-model="admin_bank_account.shaba_number">
                          </div>
                        </template>

                        <h4 class="text-center mt-5">ارسال فیش واریزی</h4>
                        <label for="deposit_receipt" class="buy-sell-upload">
                          <input type="file" id="deposit_receipt" @change="deposit_receipt_changed($event)">
                          <span>آپلود</span>
                          <i style="font-size : 24px" class="mdi mdi-cloud-upload-outline"></i>
                        </label>

                        <div v-if="deposit_receipt" class="text-center mt-2">
                          {{ deposit_receipt.name }}
                        </div>
                        
                        <div class="row my-4">
                          <div class="col-6">
                            <button class="ar-btn size-md round info block" @click="step = 1">گام قبلی</button>
                          </div>
                          <div class="col-6">
                            <button v-if="!deposit_receipt" class="ar-btn size-md round primary disabled block">ثبت درخواست</button>
                            <button v-else class="ar-btn size-md round primary block" @click="submitDepositReq()">ثبت درخواست</button>
                          </div>
                        </div>
                      </template>

                    </template>

                  </div>

                </template>

                <template v-if="step === 3">
                  
                  <div class="mdi mdi-close font-3" @click="step = 1"></div>
                  <div class="text-primary-dark pb-3 text-center">
                    <div>ثبت درخواست واریز با موفقیت انجام شد.</div>

                    <div>مقدار واریزی شما بعد از تایید تراکنش  به سبد دارایی شما اضافه می گردد.</div>
                  </div>

                </template>
                
              </div>
            </div>
            
            <div v-if="step == 1" class="ar-card mt-3">
              <div class="ar-card-header">
                <div class="ar-card-title">
                  تاریخچه واریز ها 
                </div>
                <span></span>
              </div>
              <div class="ar-card-body">

                <div v-if="!Object.keys(histories).length" class="p-4 text-center">هنوز درخواستی ایجاد نشده است.</div>

                <div class="table-responsive">
                  <table class="table ar-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>مقدار واریزی</th>
                        <th>وضعیت درخواست</th>
                        <th>زمان</th>
                        <th>جزئیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item , key) in histories" :key="key">
                        <td>{{ key+1 }}</td>
                        <td>
                          <template v-if="item.paid_currency == 'USDT'">
                            {{ item.paid_amount }} تتر 
                          </template>
                          <template v-if="item.paid_currency == 'IRR'">
                            {{formatPrice(item.paid_amount)}} تومان
                          </template>
                        </td>
                        <td>
                          <span class="text-warning" v-if="item.status == 0">در حال بررسی</span>
                          <span class="text-success" v-if="item.status == 1">تایید شده</span>
                          <span class="text-danger" v-if="item.status == 2">رد شده</span>
                        </td>
                        <td>
                          {{item.registered_at}}
                        </td>
                        <td>
                          <span :class="[
                              (item.status == 0 ? 'text-warning' : ''),
                              (item.status == 1 ? 'text-success' : ''),
                              (item.status == 2 ? 'text-danger' : '')
                            ]"
                          >
                            <router-link :to="{name:'ExchangeDetails' , params:{id:item.uuid}}">
                              <i class="mdi mdi-information-outline"></i>
                            </router-link>
                          </span>

                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
    
    <modal @close="qr_code_modal = false" :open="qr_code_modal" :maxWitdh="'400px'">
      
      <div class="ar-card">
        <div class="ar-card-header">
          <span></span>
          <div class="ar-card-title">
            اسکن کد QR 
          </div>
          <span>
            <i @click="qr_code_modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body text-right">
          <img :src="ImageUrl + admin_wallet.qr_code_file" style="width:100%;height:auto;">
        </div>
        <div class="ar-card-footer text-center">
          <button @click="qr_code_modal = false" class="ar-btn size-sm primary mx-3">تایید</button>
        </div>
      </div>

    </modal>

  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import {TheMask} from 'vue-the-mask'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import {io} from 'socket.io-client';
import Modal from '../../components/Modal.vue'
import AddWallet from '../../components/AddWallet.vue'
import HelperNav from './partials/HelperNav'
import AddBankAccount from '../../components/AddBankAccount.vue'
export default {
  name: 'Deposit',
  components:{
    Sidebar,
    HelperNav,
    AddWallet,
    AddBankAccount,
    Header,
    TheMask,
    Modal,
    vSelect
  },
  data : () => ({
    deposit:{
      admin_bank_account_id:null,
      bank_account_id:null,
      paid_currency:null,
      payment_method:null,
    },
    deposit_receipt:null,
    networks:[],
    admin_wallet:{},
    admin_bank_account:{},
    admin_bank_accounts:[],
    step : 1,
    errors:{},
    
    socket : null,

    activeTab:'rial',
    qr_code_modal:false,
    pay_modal:false,
    amount_filled:false,
    success_deposit:false,
    receipt_image_file:null,
    rial_amount:0,
    tether_amount:null,
    txid:null,
    pay_data:{},
    pay_error : null,
    histories : [],

  }),
  computed:{
    confirmed_bank_accounts()
    {
      const confirmed = this.state_bank_accounts.filter(bank_account => {
        return bank_account.status == 1;
      });

      return confirmed;
    }
  },
  watch:{
    state_bank_accounts(){
      if(this.state_bank_accounts.length){
        this.deposit.bank_account_id = this.state_bank_accounts[0].id
      }
    }
  },
  methods:{
    deposit_receipt_changed(event){
      this.deposit_receipt = event.target.files[0];
    },
    getAdminAccount(){
      if(!this.deposit.paid_amount){
        this.$notify({ group: 'foo', type: 'error', duration: 5000, text: 'لطفا مقدار واریزی را وارد نمایید'});
        return
      }
      if(this.deposit.paid_amount < 10000){
        this.$notify({ group: 'foo', type: 'error', duration: 5000, text: 'میزان پرداختی شما باید بیشتر از 10000 تومان باشد.'});
        return
      }

      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()
      this.$axios.post(`getAdminAccount` , {} ,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.admin_bank_accounts = res.data.data
        this.admin_bank_account = {}
        this.deposit.admin_bank_account_id = null
        this.step = 2;
        this.activeLoading(false)
      })
      .catch(err => {
        this.errors = err.response.data.errors
        this.activeLoading(false)
      });

    },
    submitDepositReq (){
      this.errors = {}
      this.activeLoading(true)
      const api_token = this.getToken()
      const d = new FormData();

      this.deposit_receipt ? d.append('receipt_file', this.deposit_receipt) : ''
      this.deposit.txid ? d.append('txid', this.deposit.txid) : ''
      this.admin_bank_account.id ? d.append('admin_bank_account_id', this.admin_bank_account.id) : ''
      d.append('paid_currency', this.deposit.paid_currency)
      d.append('paid_amount', this.deposit.paid_amount)
      this.deposit.bank_account_id ? d.append('bank_account_id', this.deposit.bank_account_id) : ''
      if(this.deposit.paid_currency == 'USDT')
      {
        d.append('admin_wallet', this.admin_wallet.address)
      }

      this.$axios.post(`submitDepositReq` , d,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then( () => {
        this.activeLoading(false)
        this.errors = {}
        this.deposit = {
          admin_bank_account_id:null,
          bank_account_id:null,
          paid_currency:null,
          payment_method:null,
        }
        this.socket.emit('admin_notification');

        this.step = 3
        this.buy_receipt = null
        this.getHistories()
      })
      .catch(err => {
        const error = err.response.data;
        if(error.message){
          this.$notify({
            group: 'foo',
            type: 'error',
            duration: 5000,
            text: error.message
          });
        }else{
          this.errors = error.errors
        }
        this.activeLoading(false)
      });

    },
    getNetworks (symbol){
      this.$axios.post(`getNetworks` , {symbol:symbol})
      .then(res => {
        this.networks = res.data.data
      })
      .catch( () => {
      });
    },
    CopyText(text){
      navigator.clipboard.writeText(text);
    },
    getHistories(){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`exchangesHistory`,{type:'deposit'},
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.histories = res.data.data
        this.activeLoading(false)
      })
      .catch(err => {
        this.activeLoading(false)
      });

    },
    selectAdminBankAccount(){
      const bank_id = this.deposit.admin_bank_account_id;
      const bank = this.admin_bank_accounts.find(o => o.id === bank_id);

      this.admin_bank_account = bank;
    }
  },
  mounted() {
    this.activeLoading(false)
    this.socket = io(this.socketUrl);
    this.checkAuth()
    this.checkConfirmed()
    
    this.getNetworks('USDT');
    this.getHistories()
  }
}
</script>